import { render, staticRenderFns } from "./message-list.vue?vue&type=template&id=0aecc431&scoped=true&"
import script from "./message-list.vue?vue&type=script&lang=js&"
export * from "./message-list.vue?vue&type=script&lang=js&"
import style0 from "./message-list.vue?vue&type=style&index=0&id=0aecc431&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aecc431",
  null
  
)

export default component.exports